import { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './hooks/useAuth';

// Code-splitting (v5): o dono logado não baixa a cena de boot do Login
// (2 engines de canvas, ~1100 linhas) e o visitante não baixa o HUD inteiro.
const Login = lazy(() => import('./pages/Login').then((m) => ({ default: m.Login })));
const Home = lazy(() => import('./pages/Home').then((m) => ({ default: m.Home })));

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-jarvis-bg text-jarvis-muted">
      <Loader2 className="h-5 w-5 animate-spin" />
    </div>
  );
}

function Gate() {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  return user ? <Home /> : <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <Suspense fallback={<Spinner />}>
        <Gate />
      </Suspense>
    </AuthProvider>
  );
}
